import React from 'react';
import EDBox from '../../BaseComponents/EDBox/EDBox';

export const AppContainer: React.FC<React.PropsWithChildren> = props => {
  return (
    <EDBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        minHeight: '100dvh',
        overflow: 'hidden',
        '@media print': {
          height: 'auto',
          minHeight: 'auto',
        },
      }}
    >
      {props.children}
    </EDBox>
  );
};
